<template>
  <div>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <p class="headline text-xs-left" v-if="this.formaction == 'create'">
                Add Integration
              </p>
              <p class="headline text-xs-left" v-if="this.formaction == 'edit'">
                Edit Integration
              </p>
            </v-flex>
            
              <v-flex xs6>
                <v-text-field
                  v-model="Form.integrationAlias"
                  hide-details
                  :counter="50"
                  label="Alias*"
                  name="Alias"
                />
              </v-flex>
              <v-flex xs6>
              <v-text-field
                v-model="Form.integrationName"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="integrationForm"
                :error-messages="errors.collect('integrationForm.integrationName')"
                hide-details
                :counter="50"
                label="Integration Name*"
                name="integrationName"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.apiKey"
                hide-details
                :counter="50"
                label="API Key*"
                name="apiKey"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.integrationValue"
                hide-details
                :counter="50"
                label="Value*"
                name="Value"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="portalSelect"
                :items="portallist"
                item-text="portalName"
                item-value="id"
                chips
                label="Applies to the following Portals"
                multiple
              ></v-select>
            </v-flex>
            <v-flex xs12 class="input-container">
              <span v-if="Form.enabled" style="padding-top: 25px;">Enabled</span>
              <span v-else style="padding-top: 25px;">Disabled</span>
              <v-switch v-model="Form.enabled" style="padding-left: 15px;"></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="SaveDocument('integrationForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>


<script>

export default {
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    portal: {
      type: Object,
      default() {
        return {};
      }
    },
    form: {
      type: Object,
      default() {
        return {};
      }
    },
    formaction: {
      type: String,
      default: ""
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    portalSelect: [],
    Form: {
      id: null,
      portalID: [],
      integrationAlias: null,
      integrationName: null,
      apiKey: null,
      integrationValue: null,
      enabled: false
    }
  }),
  watch: {
    form: {
      handler: function() {
        this.Form = this.form;
        this.portalSelect = this.form.portalID
      },
      deep: true
    },
    portalSelect: {
      handler: function() {
        this.Form.portalID = this.portalSelect;
      },
      deep: true
    }
  },
  mounted() {
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  },
  methods: {
    CloseDialog() {
      this.$emit("Dialog", false);
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          //console.log("Save Document + " + this.formaction);
          switch (this.formaction) {
            case "create":
              this.$store.dispatch("Admin/createDocument", [
                this.admin.Collection,
                this.Form,
                "Admin/setDocumentResult"
              ]);
              break;
            case "edit":
              var id = this.Form.id;
              //console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              //console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Admin/updateDocument", [
                this.admin.Collection,
                id,
                this.Form
              ]);
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    }
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
</style>